import React, {useState} from "react";
import {Button, Col, Layout, Popover} from "antd";
import {useNavigate} from "react-router-dom";
import useShared from "../../../_common/_shared";
import {useTranslation} from "react-i18next";
import EditNavigationModal_1 from "./editNavigationModal";
import FooterTime from "./latestTime/footerTime";

const {Sider} = Layout;

export const Sider_1 = ({routes}) => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const {IconModule, IconCommon} = useShared();

    const [openEditNavModal, setOpenEditNavModal] = useState(false);

    return (
        <Sider width={81} id={"layout-sider"} breakpoint={"md"} collapsedWidth={"0"}>
            <div className="sider-wrapper" style={{marginTop: 64}}>
                <div className="sider-fav-container">
                    {routes.map((route) => {
                        if (route?.sub && !!route?.sub?.length) {
                            const content = (
                                <div id={"layout-sider-popover"} className={"popover-select-item-list"}>
                                    {route?.sub?.map((subRoute) => (
                                        <Button
                                            type={"text"}
                                            key={subRoute?.label}
                                            xs={24}
                                            className={`layout-sider-popover-btn text-center `}
                                            onClick={() => subRoute?.type === "_blank" ? window.open(subRoute?.path, "_blank") : navigate(subRoute?.path)}
                                        >
                                            <IconModule
                                                iconName={`md-${subRoute?.label?.replaceAll(" ", "")?.replaceAll(".", "").replaceAll("-", "")?.toLowerCase()}`}
                                                layout={1}
                                            />
                                            <p className={"ms-2"}>
                                                {t(`module.${subRoute?.label?.replaceAll(" ", "_")?.replaceAll(".", "")?.toLowerCase()}`)}
                                            </p>
                                        </Button>
                                    ))}
                                </div>
                            );

                            if (route?.key === "more") return (
                                <Popover
                                    destroyTooltipOnHide
                                    content={content}
                                    placement={"left"}
                                    getPopupContainer={(triggerNode) => triggerNode.parentElement}
                                >
                                    <Col span={24} className={"text-center mb-4 cursor-pointer"}>
                                        <IconModule
                                            iconName={`md-${route?.label?.replaceAll(" ", "")?.replaceAll(".", "").replaceAll("-", "")?.toLowerCase()}`}
                                            layout={1}
                                        />
                                        <p className={"mt-1"}>
                                            {t(`module.${route?.label?.replaceAll(" ", "_")?.replaceAll(".", "")?.toLowerCase()}`)}
                                        </p>
                                    </Col>
                                </Popover>
                            )

                            return null
                        }

                        return (
                            <Col
                                span={24}
                                className={"text-center mb-4 cursor-pointer"}
                                key={route?.label}
                                onClick={() => route?.type === "_blank" ? window.open(route?.path, "_blank") : navigate(route?.path)}
                            >
                                <IconModule
                                    iconName={`md-${route?.label?.replaceAll(" ", "")?.replaceAll(".", "").replaceAll("-", "")?.toLowerCase()}`}
                                    layout={1}
                                />
                                <p className={"mt-1"}>
                                    {t(`module.${route?.label?.replace(".", "")?.replace(/[-\s+]/g, "_").toLowerCase()}`)}
                                </p>
                            </Col>
                        );
                    })}
                </div>
                <div>
                    <div className={"navItem"}>
                        <IconCommon className={"footerIcon"} iconName={"cm-time-regular"}/>
                        <FooterTime/>
                    </div>
                </div>
            </div>
            <EditNavigationModal_1 isModalOpen={openEditNavModal} handleCancel={() => setOpenEditNavModal(false)}/>
        </Sider>
    );
};
